<template>
    <div class="modal-container has-text-centered">
         <div class="delete is-large is-pulled-right" @click="$emit('close')"></div>
        <div class="has-background-dark"> <div class="is-size-4"><span class=" has-text-white">Check for Additions</span></div></div>
        <div>&nbsp;</div>

        <div v-if="offer">
            <div>You have made additions to this bundle after sharing it. Would you like to review the additions and pushlish them for those who imported the bundle to see?</div>
            <button id="pubButt" class="button is-coolGreen is-small top20" @click="doUpdate">REVIEW</button>&nbsp;<button class="button top20 is-small" @click="cancel">CANCEL</button>
        </div>

         <div v-if="noNeed && !checking">
             <div>You have made no additions to this bundle since you shared it.</div>
            <button class="button is-coolGreen is-small top10" @click="cancel">DONE</button>
         </div>

        <div v-if="checking">
            <br>
             <div id="spin">
    
             </div>
             <br>
        </div>
        <div>&nbsp;</div>
    </div>
</template>

<script>

export default{
   props: {id: Number, bund: Object},
   data: function() {
       return {
           offer: false,
           noNeed: false,
           checking: true,
           dirtyCards: []
       }
   },
   mounted: function(){
       var self = this

       az.addRemSpinner(true, 'id', 'spin')

       function w(data){
           az.addRemSpinner(false, 'id', 'spin')
           self.checking = false
           if(data.dirtyCards.length){
             self.dirtyCards = data.dirtyCards;
             self.offer = true;
           } else {
            self.noNeed = true;
           }

       }

       function n(){
            az.addRemSpinner(false, 'id', 'spin')
       }

       this.$root.app.apiClient.get('subs/data/originatordirtycards/' + this.id, {}, w, n);

   },

   methods: {
       cancel: function(){
           this.$emit('close')
       },

       doUpdate: function(){
           var self = this;

         
 
       function findIt(arr){
                    
                    for(var i=0; i < arr.length; i++){
                        let b = arr[i];
    
                        if(b.id == self.id){
                            return b
                        } else if(b.children.length){
                            let res = findIt(b.children)
                            if(res !== false){
                                return  res
                            } 
                        } else {
                            continue
                        }
                    }
                    return false
                }

        let bundle = findIt(self.$root.app.treeNoInbox)

        var bundleCopy = JSON.parse(JSON.stringify(bundle))

 

       bundleCopy.items = bundleCopy.items.filter(e => {
           return self.dirtyCards.includes(e.id)
       })

       self.$router.push({name: 'sb', params: {theBundle: [bundleCopy], isPush: true}})
       self.$emit('close')
    }


   }

}

</script>

<style scoped>
    .modal-container{
        max-width: 400px;
    }

    .title{
        margin: 0 50px 0 50px
    }

</style>